"use client";

import { useState, useEffect } from "react";
import { REGEXP_ONLY_DIGITS } from "input-otp";
import {
    InputOTP,
    InputOTPGroup,
    InputOTPSlot,
} from "@/components/ui/input-otp";

interface OtpInputProps {
    onChange: (code: string) => void;
}

const OtpInput: React.FC<OtpInputProps> = ({ onChange }) => {
    const [otp, setOtp] = useState("");

    useEffect(() => {
        onChange(otp);
    }, [otp, onChange]);

    return (
        <div className="flex justify-center w-full">
            <InputOTP
                maxLength={6}
                pattern={REGEXP_ONLY_DIGITS}
                value={otp}
                onChange={(value) => setOtp(value)}
            >
                <InputOTPGroup className="ltr-input">
                    {[...Array(6)].map((_, i) => (
                        <InputOTPSlot key={i} index={i} />
                    ))}
                </InputOTPGroup>
            </InputOTP>
        </div>
    );
};

export default OtpInput;
